import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {BackendService} from '../../services/backend.service';
import {WpcheckAnfrage} from '../anfrage/wpcheck.anfrage';
import {DebugService} from '../../debug/debug.service';

/**
 * Service for dealing with the backend and make request to the backend.
 */
@Injectable({
  providedIn: 'root'
})
export class WpcheckBackendService extends BackendService {

  /**
   * @inheritDoc
   */
  requestIdName = 'wpc-requestid';

  /**
   * @inheritdoc
   */
  backendDataEndpoint = '/wpc/data/';

  /**
   * constructor.
   * @param http
   * @param backendService
   * @param debugService
   */
  constructor(protected http: HttpClient, private backendService: BackendService, protected debugService: DebugService) {
    super(http, debugService);
  }

  /**
   * @inheritDoc
   * this is a small workaround so other components can still access the generic backendservice and will get the real advisor name
   * @param advisor
   */
  setAdvisor(advisor: string) {
    super.setAdvisor(advisor);

    this.backendService.setAdvisor(advisor);
  }

  /**
   * starts the calculation
   * @param anfrage
   * @param requestId
   */
  result(anfrage: WpcheckAnfrage, requestId: string): Observable<any> {
    return this.http.post('/wpc/result/' + requestId, anfrage).pipe(
      tap(data => {
        if (data.debug) {
          this.addDebug(data.debug);
        }
      })
    );
  }
}
